import { render } from "./list_base.vue?vue&type=template&id=de603d04"
import script from "./list_base.vue?vue&type=script&lang=js"
export * from "./list_base.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/oralhealthmap.uz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__